import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

// Config
import { getRoute, urls } from "src/config/routes";

// Components
import SectionWrapper from "../../components/SectionWrapper";
import CaseStatementsPanel from "../../components/CaseStatementsPanel";
import RecipientsProvider from "../../context/RecipientsProvider";

const InterviewPage = () => {
  const { data } = useSelector(s => s.caseDetail);
  const history = useHistory();

  useEffect(() => {
    if (data && data.isIntel)
      history.push(
        getRoute(urls.caseDetail, {
          caseId: data.id
        })
      );
  }, [data]);

  return (
    <SectionWrapper>
      <RecipientsProvider>
        <CaseStatementsPanel isInterview />
      </RecipientsProvider>
    </SectionWrapper>
  );
};

export default InterviewPage;
